"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var TaxTypes_1 = require("../../../../../../common/enum/TaxTypes");
var useTaxes = function (prices) {
    var _a, _b, _c, _d, _e, _f;
    var priceDisplay = usePlatformConfig_1.default().platformConfig.priceDisplay;
    var taxes = react_1.useMemo(function () { var _a; return (_a = prices
        .find(function (p) { var _a; return ((_a = p.taxes) === null || _a === void 0 ? void 0 : _a.length) && p.money.currency === priceDisplay.primary.currency; })) === null || _a === void 0 ? void 0 : _a.taxes.reduce(function (acc, tax) {
        acc[tax.type] = tax.money.amount;
        return acc;
    }, {}); }, [priceDisplay, prices]);
    return {
        novaTotalTax: (_a = taxes) === null || _a === void 0 ? void 0 : _a[TaxTypes_1.TaxTypes.NOVA_TOTAL],
        frt: (_b = taxes) === null || _b === void 0 ? void 0 : _b[TaxTypes_1.TaxTypes.FRT],
        vat: (_c = taxes) === null || _c === void 0 ? void 0 : _c[TaxTypes_1.TaxTypes.VAT],
        handlingFee: (_d = taxes) === null || _d === void 0 ? void 0 : _d[TaxTypes_1.TaxTypes.HANDLING_FEE],
        gst: (_e = taxes) === null || _e === void 0 ? void 0 : _e[TaxTypes_1.TaxTypes.GST],
        gvt: (_f = taxes) === null || _f === void 0 ? void 0 : _f[TaxTypes_1.TaxTypes.GVT],
    };
};
exports.default = useTaxes;
